import React, { Component } from "react";
import * as Constants from "../../../../common/Global/constants";
import { SearchSpan, DialogSaveButton, TableCheckBox } from "../../../../common/Global/globalStyles.style";
import FilterDropDown from "../../../../common/DropdownMenus/FilterDropdown";
import Pagination from "../../../../common/Global/pagination";
import { getLocalStorageVariables, isEmptyVariable, sortTable, isEmptyArray, handleTokenExpiry } from "../../../../common/Global/commonFunctions";
import { Modal } from "react-bootstrap";
import RegularDropdown from "../../../../common/DropdownMenus/RegularDropdown";
import IndustryTreeDialog from "./industryTree";
import AlertDialog from "../../../../common/AlertDialog";
let userDetails = getLocalStorageVariables();

const departmentDropdownDefaultValue = "Select Department";
const departmentFilterDropdownDefaultValue = "All";

class DocumentSampleList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			componentDidMountFlag: false,
			apiSearchKey: "",
			searchkey: "",
			currentPageNo: 1,
			showLoader: false,
			resultSize: Constants.RESULT_SIZE,
			totalCount: 0,
			datalist: [],
			resultSizePlaceholder: Constants.RESULT_SIZE,
			resultSizeArr: JSON.parse(JSON.stringify(Constants.RESULT_SIZE_DD_ARR)),
			sort: "",
			sortDir: "",

			selectedId: "",

			departmentArr: [],
			selectedDepartmentName: departmentDropdownDefaultValue,
			selectedDepartmentId: "",
			formErrors: {},

			showTableFlag: false,
			industryName: "",
			rootIndustryId: "",
			showIndustryTreeDialog: false,
			idToBeExpandedAfterAddingChild: "",
			showAlertDialogInfo:false,
            alertDialogMessageInfo:""
		};
		userDetails = getLocalStorageVariables();
	}
	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showCopyIndustryDialog) {
			this.setState(
				{
					showLoader: true,

					showTableFlag: false,
					searchkey: "",
					currentPageNo: 1,
					resultSize: JSON.parse(JSON.stringify(Constants.RESULT_SIZE)),
					resultSizeArr: JSON.parse(JSON.stringify(Constants.RESULT_SIZE_DD_ARR)),
					sort: "",
					sortDir: "",
					resultSizePlaceholder: Constants.RESULT_SIZE ,
				},
				() => {
					this.getInitData();
				}
			);
		}
	}

	handleChangeSearch = (e) => {
		const { name, value } = e.target;

		this.setState({
			[name]: value,
		});
	};

	onSearchIconClick = () => {
		this.setState(
			{
				currentPageNo: 1,
			},
			() => {
				this.getIndustryList();
			}
		);
	};

	handleStopPropagation = (e) => {
		e.stopPropagation();
	};

	onEnterBtnPress = (e) => {
		var code = e.keyCode || e.which;
		if (code === 13) {
			this.setState(
				{
					currentPageNo: 1,
				},
				() => {
					this.getIndustryList();
				}
			);
		}
	};
	sortTableLocal = (sortColumn) => {
		let sortObj = sortTable(sortColumn, this.state.sort, this.state.sortDir);

		this.setState(
			{
				sort: sortObj.sortTemp,
				sortDir: sortObj.sortDirTemp,
			},
			() => {
				this.getIndustryList();
			}
		);
	};

	handleIndustryTreeDialogClose = () => {
		this.setState({
			showIndustryTreeDialog: false,
			rootIndustryId: "",
		});
	};

	handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

	showIndustryTreeDialog = (item) => {
		this.setState({
			showIndustryTreeDialog: true,
			rootIndustryId: item.industryId,
			rootNode: item,
		});
	};

	resultSizeDropdownClick = (item, selectedIndex) => {
		let tempArr = this.state.resultSizeArr;
		let placeholder = "";

		for (const [i, value] of tempArr.entries()) {
			if (i === selectedIndex) {
				tempArr[i].isSelected = true;
				placeholder = value.label ;
			} else {
				tempArr[i].isSelected = false;
			}
		}

		this.setState(
			{
				resultSizeArr: tempArr,
				resultSize: item.label,
				resultSizePlaceholder: placeholder,
			},
			() => {
				this.getIndustryList();
			}
		);
	};

	deptFilterDropdownClick = (item, selectedIndex) => {
		let placeholder = "";
		let id = "";
		let filterDeptArr = this.state.filterDeptArr;

		for (const [i, value] of filterDeptArr.entries()) {
			if (i === selectedIndex) {
				filterDeptArr[i].isSelected = true;
				placeholder = value.deptName;
				id = value.departmentId;
			} else {
				filterDeptArr[i].isSelected = false;
			}
		}

		this.setState(
			{
				currentPageNo: 1,
				selectedFilterDepartmentName: placeholder,
				selectedFilterDepartmentId: id,
			},
			() => {
				this.getIndustryList();
			}
		);
	};

	handleSelection = (e) => {
		e.stopPropagation();
		let selectedId = "";
		let index = e.target.name;

		if (this.state.selectedId !== this.state.datalist[index].industryId) {
			selectedId = this.state.datalist[index].industryId;
		}
		this.setState({
			selectedId: selectedId,
		});
	};

	deptDropdownClick = (item) => {
		let FormErrorsTemp = this.state.formErrors;

		if (this.state.submitClickedAtleastOnce) {
			FormErrorsTemp["deparment"] = "";
		}

		this.setState(
			{
				currentPageNo: 1,
				selectedDepartmentName: item.name,
				selectedDepartmentId: item.departmentId,
				formErrors: FormErrorsTemp,
			},
			() => {
				this.getInitDataMultiple();
			}
		);
	};
	/*****************************API*********************************/

	getInitData = () => {
		Promise.all([
			fetch(Constants.GetIndustriesCreateMasterData, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
				}),
			}),
			fetch(Constants.GetCopyRootIndustryMasterData, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
					pageNo: this.state.currentPageNo,
					search: this.state.searchkey,
					resultsize: this.state.resultSize,
					sort: this.state.sort,
					sortDir: this.state.sortDir,

					status: "Active",
				}),
			}),
		])
			.then(([masterRes, generalRes]) => {
				return Promise.all([masterRes.json(), generalRes.json()]);
			})
			.then(([masterRes, generalRes]) => {
				let datalistTemp = [];
				let totalCountTemp = 0;

				let deptTemp = [];
				let targetFilterDeptTemp = [];

				if(handleTokenExpiry(masterRes.responseCode)) return;
				else if (masterRes.responseCode === Constants.CODE_SUCCESS) {
					deptTemp = masterRes.data.departments;
				} else {
				}

				if(handleTokenExpiry(generalRes.responseCode)) return;
				else if (generalRes.responseCode === Constants.CODE_SUCCESS) {
					datalistTemp = generalRes.data.result;
					targetFilterDeptTemp = generalRes.data.departments;

					totalCountTemp = generalRes.data.count;
				} else {
					datalistTemp = [];
				}

				//if user belongs to single dept then dont show the dropdown
				let selectedDepartmentId = "";
				let selectedDepartmentName = departmentDropdownDefaultValue;
				let showTableFlag = false;

				if (!isEmptyArray(deptTemp) && deptTemp.length === 1) {
					selectedDepartmentId = deptTemp[0].departmentId;
					selectedDepartmentName = deptTemp[0].name;
					showTableFlag = true;
				}

				//Filter Dept array
				let filterDeptArr = [];
				let selectedFilterDepartmentId = "-100";
				let selectedFilterDepartmentName = "All";
				if (!isEmptyArray(targetFilterDeptTemp) && targetFilterDeptTemp.length === 1) {
				} else {
					let obj = {
						departmentId: "-100",
						deptName: departmentFilterDropdownDefaultValue,
						isSelected: true,
					};
					filterDeptArr = [...targetFilterDeptTemp];
					filterDeptArr.splice(0, 0, obj);
				}

				this.setState({
					componentDidMountFlag: true,
					showLoader: false,

					datalist: datalistTemp,
					totalCount: totalCountTemp,

					departmentArr: deptTemp,

					filterDeptArr: filterDeptArr,
					selectedFilterDepartmentId: selectedFilterDepartmentId,
					selectedFilterDepartmentName: selectedFilterDepartmentName,

					selectedDepartmentId: selectedDepartmentId,
					selectedDepartmentName: selectedDepartmentName,
					formErrors: {},
					selectedId: "",

					showTableFlag: showTableFlag,
				});
			});
	};

	getInitDataMultiple = () => {
		this.setState({
			showLoader: true,
			showTableFlag: false,
		});

		let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
			pageNo: this.state.currentPageNo,
			search: this.state.searchkey,
			resultsize: this.state.resultSize,
			sortDir: this.state.sortDir,
			sort: this.state.sort,

			//TODO
			status: "Active",
		};

		if (this.state.departmentArr.length > 1 && this.state.selectedDepartmentName !== departmentFilterDropdownDefaultValue) {
			// exclude this department
			postParam.departmentId = this.state.selectedDepartmentId;
		}

		if (this.state.filterDeptArr.length > 1 && this.state.selectedFilterDepartmentName !== departmentFilterDropdownDefaultValue) {
			postParam.copyFromDepartmentId = this.state.selectedFilterDepartmentId;
		}
		fetch(Constants.GetCopyRootIndustryMasterData, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(postParam),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if(handleTokenExpiry(data.responseCode)) return;
				else if (data.responseCode === Constants.CODE_SUCCESS) {
					let targetFilterDeptTemp = [];
					targetFilterDeptTemp = data.data.departments;
					//Filter Dept array
					let filterDeptArr = [];
					let selectedFilterDepartmentId = "-100";
					let selectedFilterDepartmentName = "All";
					if (!isEmptyArray(targetFilterDeptTemp) && targetFilterDeptTemp.length === 1) {
					} else {
						let obj = {
							departmentId: "-100",
							deptName: departmentFilterDropdownDefaultValue,
							isSelected: true,
						};
						filterDeptArr = [...targetFilterDeptTemp];
						filterDeptArr.splice(0, 0, obj);
					}
					this.setState({
						showLoader: false,
						datalist: data.data.result,
						totalCount: data.data.count,
						apiSearchKey: this.state.searchkey,
						showTableFlag: true,

						filterDeptArr: filterDeptArr,
						selectedFilterDepartmentId: selectedFilterDepartmentId,
						selectedFilterDepartmentName: selectedFilterDepartmentName,
					});
				} else {
					this.setState({
						datalist: [],
						showLoader: false,
						totalCount: 0,
						componentDidMountFlag: true,
						apiSearchKey: this.state.searchkey,
					});
				}
			});
	};
	
	getIndustryList = () => {
		this.setState({
			showLoader: true,
			showTableFlag: false,
		});

		let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
			pageNo: this.state.currentPageNo,
			search: this.state.searchkey,
			resultsize: this.state.resultSize,
			sortDir: this.state.sortDir,
			sort: this.state.sort,

			//TODO
			status: "Active",
		};

		if (this.state.departmentArr.length > 1 && this.state.selectedDepartmentName !== departmentFilterDropdownDefaultValue) {
			// exclude this department
			postParam.departmentId = this.state.selectedDepartmentId;
		}

		if (this.state.filterDeptArr.length > 1 && this.state.selectedFilterDepartmentName !== departmentFilterDropdownDefaultValue) {
			postParam.copyFromDepartmentId = this.state.selectedFilterDepartmentId;
		}
		fetch(Constants.GetCopyRootIndustryMasterData, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(postParam),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if(handleTokenExpiry(data.responseCode)) return;
				else if (data.responseCode === Constants.CODE_SUCCESS) {
					this.setState({
						showLoader: false,
						datalist: data.data.result,
						totalCount: data.data.count,
						apiSearchKey: this.state.searchkey,
						showTableFlag: true,
					});
				} else {
					this.setState({
						datalist: [],
						showLoader: false,
						totalCount: 0,
						componentDidMountFlag: true,
						apiSearchKey: this.state.searchkey,
					});
				}
			});
	};

	onChangePage = (page) => {
		// update state with new page of items
		if (page !== this.state.currentPageNo) {
			this.setState({
				showLoader: true,
			});

			let postParam = {
				email: userDetails.email,
				accessToken: userDetails.accessToken,
				pageNo: page,
				search: this.state.searchkey,
				resultsize: this.state.resultSize,
				// status: this.state.status,
				// departmentOnly: this.state.deptOnly,
				sort: this.state.sort,
				sortDir: this.state.sortDir,

				status: "Active",
			};

			if (this.state.departmentArr.length > 1 && this.state.selectedDepartmentName !== departmentFilterDropdownDefaultValue) {
				postParam.departmentId = this.state.selectedDepartmentId;
			}
			if (this.state.filterDeptArr.length > 1 && this.state.selectedFilterDepartmentName !== departmentFilterDropdownDefaultValue) {
				postParam.copyFromDepartmentId = this.state.selectedFilterDepartmentId;
			}

			fetch(Constants.GetCopyRootIndustryMasterData, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams(postParam),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					if(handleTokenExpiry(data.responseCode)) return;
					else if (data.responseCode === Constants.CODE_SUCCESS) {
						this.setState({
							showLoader: false,
							datalist: data.data.result,
							totalCount: data.data.count,
							apiSearchKey: this.state.searchkey,
							currentPageNo: page,
						});
					} else {
						this.setState({
							datalist: [],
							showLoader: false,
							apiSearchKey: this.state.searchkey,
						});
					}
				});
		}
	};

	handleCopyIndustry = () => {
		this.setState({
			showLoader: true,
		});

		let isError = false;
		let FormErrorsTemp = {};

		if (isEmptyVariable(this.state.selectedDepartmentName) || this.state.selectedDepartmentName === departmentDropdownDefaultValue) {
			isError = true;
			FormErrorsTemp["deparment"] = "Please select the department";
		}

		if (isEmptyVariable(this.state.selectedId)) {
			isError = true;
			FormErrorsTemp["selectId"] = "Please select the Industry";
		}

		if (isError) {
			this.setState({
				formErrors: FormErrorsTemp,
				showLoader: false,
			});
		} else {
			fetch(Constants.CopyRootIndustry, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
					rootIndustryId: this.state.selectedId,
					departmentId: this.state.selectedDepartmentId,
				}),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					if(handleTokenExpiry(data.responseCode)) return;
					else if (data.responseCode === Constants.CODE_SUCCESS) {
						this.setState(
							{
								showLoader: false,
							},
							() => {
								this.props.handleCopyIndustryClose();
							}
						);
					} else {
						this.setState({
							showLoader: false,
							showAlertDialogInfo:true,
            				alertDialogMessageInfo:data.responseMessage
						});
					}
				});
		}
	};
	/**************************************************************/

	render() {
		return (
			<section>
				<Modal className="task-select-table-dialog custom-dialog" show={this.props.showCopyIndustryDialog} backdrop="static">
					<Modal.Header>
						<h5>Copy Industry</h5>
						<button onClick={this.props.handleCopyIndustryClose} type="button" data-dismiss="modal">
							<span class="material-icons">close</span>
						</button>
					</Modal.Header>
					<hr />
					<div className="modal-body">
						{this.state.showLoader && (
							<div class="loader"></div>
						)}

						{
							// Need to check component did mount flag, other wise until api is called,
							// it shows no items found layout.
							this.state.componentDidMountFlag && (
								<div className="body-wrapper">
									{!isEmptyArray(this.state.departmentArr) && this.state.departmentArr.length > 1 && (
										<div class="addnew-modal-form-group">
											<p>Choose Your Department*</p>
											<RegularDropdown
												placeholder={this.state.selectedDepartmentName}
												dropdownArr={this.state.departmentArr}
												labelParam="name"
												onDropDownItemClick={this.deptDropdownClick}
												defaultPlaceholderDropDown={departmentDropdownDefaultValue}
											/>
											{!isEmptyVariable(this.state.formErrors["deparment"]) && <span class="cm-error">{this.state.formErrors["deparment"]}</span>}
										</div>
									)}
									{this.state.showTableFlag && (
										<div>
											<div className="search-addnew-bg">
												<div className="search-addnew">
													<div className="search-filter-layout">
														<FilterDropDown
															placeholder={this.state.resultSizePlaceholder}
															dropdownArr={this.state.resultSizeArr}
															onDropDownItemClick={this.resultSizeDropdownClick}
															themeSettings={this.props.themeSettings}
															mleft={0}
														/>
														<div className="search-col m-l-10">
															<input
																name="searchkey"
																type="text"
																onChange={this.handleChangeSearch}
																placeholder="Search"
																onKeyPress={this.onEnterBtnPress}
																value={this.state.searchkey}
															/>
															<SearchSpan
																themeSettings={this.props.themeSettings}
																onClick={this.onSearchIconClick}
																className="material-icons"
															>
																{" "}
																search{" "}
															</SearchSpan>
														</div>

														

														{this.state.filterDeptArr.length > 0 && (
															<FilterDropDown
																placeholder={this.state.selectedFilterDepartmentName}
																dropdownArr={this.state.filterDeptArr}
																onDropDownItemClick={this.deptFilterDropdownClick}
																name={"deptName"}
																themeSettings={this.props.themeSettings}
																dropdownWidth={"120px"}
															/>
														)}
													</div>
												</div>
											</div>
											{!isEmptyArray(this.state.datalist) && (
												<div className="common-tab-bg">
													<div className="common-table" style={{ width: "100%" }}>
														<table className="table">
															<thead>
																<tr>
																	<th className="text-center" width={"8%"}></th>
																	<th className="text-center" width={"5%"}>
																		No
																	</th>
																	<th>
																		<div className="sort-header">Industry</div>
																	</th>

																	<th>
																		<div className="sort-header">Department</div>
																	</th>
																</tr>
															</thead>
															<tbody>
																{!isEmptyArray(this.state.datalist) &&
																	this.state.datalist.map((item, idx) => {
																		return (
																			<tr onClick={this.showIndustryTreeDialog.bind(this, item)}>
																				<td>
																					<TableCheckBox
																						onClick={this.handleStopPropagation}
																						themeSettings={this.props.themeSettings}
																					>
																						<input
																							type="checkbox"
																							name={idx}
																							id={item.industryId}
																							onChange={this.handleSelection}
																							checked={this.state.selectedId === item.industryId ? true : false}
																						/>
																						<label for={item.industryId} style={{ marginLeft: 6 }}></label>
																					</TableCheckBox>
																				</td>
																				<td className="text-center">
																					{(this.state.currentPageNo - 1) * this.state.resultSize + ++idx}
																				</td>
																				<td>{item.industryName}</td>
																				<td>{item.deptName}</td>
																			</tr>
																		);
																	})}
															</tbody>
														</table>
													</div>
												</div>
											)}
											{!isEmptyVariable(this.state.formErrors["selectId"]) && <span class="cm-error">{this.state.formErrors["selectId"]}</span>}

											{this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) && (
												<div class="no-items-layout">
													<div class="no-items-card">
														<h6>
															{isEmptyVariable(this.state.apiSearchKey) ? Constants.NO_RECORDS_WARNING : Constants.EMPTY_SEARCH_WARNING}
														</h6>
													</div>
												</div>
											)}
											<div className="pagination-layout">
												<div className="row custom-row">
													<div className="col-md-9 custom-col">
														{this.state.totalCount > this.state.datalist.length && (
															<Pagination
																totalLength={this.state.totalCount}
																items={this.state.datalist}
																onChangePage={this.onChangePage}
																pageSize={this.state.resultSize}
																currentPageNo={this.state.currentPageNo}
																initialPage={this.state.currentPageNo}
																themeSettings={this.props.themeSettings}
															/>
														)}
													</div>
													<div className="col-md-3 custom-col">
														<p>{"Total Records: " + this.state.totalCount}</p>
													</div>
												</div>
											</div>
										</div>
									)}
									{/* <div class="addnew-modal-form-group">
										{!isEmptyVariable(this.state.formErrors["apiErr"]) && <span class="cm-error">{this.state.formErrors["apiErr"]}</span>}
									</div> */}
									<div class="modal-close-save">
										<div class="close-save-col">
											<button onClick={this.props.handleCopyIndustryClose} type="button" class="modal-close">
												Cancel
											</button>
											<DialogSaveButton themeSettings={this.props.themeSettings} onClick={this.handleCopyIndustry} type="button">
												Save
											</DialogSaveButton>
										</div>
									</div>
								</div>
							)
						}
					</div>
					<IndustryTreeDialog
						showIndustryTreeDialog={this.state.showIndustryTreeDialog}
						handleIndustryTreeDialogClose={this.handleIndustryTreeDialogClose}
						rootIndustryId={this.state.rootIndustryId}
						rootNode={this.state.rootNode}
						idToBeExpandedAfterAddingChild={this.state.idToBeExpandedAfterAddingChild}
						themeSettings={this.props.themeSettings}
					/>
				</Modal>
				<AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
			</section>
		);
	}
}
export default DocumentSampleList;
